import { z } from 'zod';

export const formSchema = z.object({
  he_so: z
    .union([
      z.string().transform(val => {
        const num = parseFloat(val);
        // Nếu là số âm hoặc không phải số, trả về 0
        return !isNaN(num) && num >= 0 ? num : 0;
      }),
      z.number().transform(val => (val >= 0 ? val : 0))
    ])
    .default(0),
  trang_thai: z.string().default('0')
});

export type FormValues = z.infer<typeof formSchema>;

export const initialValues: FormValues = {
  he_so: 0,
  trang_thai: '1'
};
